import { gql } from '@apollo/client';

export const GET_SCREENER_SESSION = gql`
  query ScreenerSession($sessionId: ID!) {
    screenerSession(id: $sessionId) {
      id
      authenticationToken
      tester {
        id
        status
        mrId
        cintId
        user {
          id
          tester
          guest
        }
        project {
          participantsSource
        }
        segment {
          id
          device
          surveys {
            id
            surveyType
            questions {
              id
              label
              randomize
              questionType
              questionOrder
              questionOptions(sessionId: $sessionId) {
                id
                label
                disqualify
                qualify
                order
                optionType
              }
            }
          }
          recruitParticipantToken {
            id
            token
          }
        }
        project {
          id
          name
          description
          testType
          welcomeTitle
          welcomeContent
          disqualifyRedirectUrl
          hasMrId
          projectConsentForms {
            id,
            consentForm {
              id,
              name,
              filePath
            }
          }
        }
      }
    }
  }
`;

export const CREATE_SCREENER_SESSION_ANSWER = gql`
  mutation CreateScreenerSessionAnswer($attributes: [ScreenerSessionAnswerAttributes!]!, $cintId: String, $mrId: String) {
    createScreenerSessionAnswer(attributes: $attributes, cintId: $cintId, mrId: $mrId) {
      screenerSessionAnswer {
        id
      }
      testSession {
        id
        authenticationToken
      }
      tester {
        id
        status
        mrId
        cintId
        project {
          id
          participantsSource
        }
      }
      errors
    }
  }
`;
